/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-filter': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<defs><path pid="0" d="M9.53 0c.356 0 .572.391.421.706L9.91.778 6.72 5.377v2.448c0 .241-.167.441-.386.483l-.084.008a.476.476 0 0 1-.462-.402l-.008-.089V5.218c0-.078.018-.154.05-.222l.04-.066L8.61.98H1.39l2.74 3.95a.502.502 0 0 1 .084.211l.006.077V9.51c0 .27-.21.49-.47.49a.476.476 0 0 1-.462-.402l-.007-.088V5.377L.09.777c-.21-.3-.033-.713.3-.77L.47 0h9.058z" id="svgicon-icon-filter-a"/></defs><use _fill="#234357" fill-rule="nonzero" xlink:href="#svgicon-icon-filter-a"/>'
  }
})
